import React from 'react';

export const Switch = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M19.5 8.30977H3.96562" stroke="black" strokeWidth="1.5" />
    <path
      d="M7.51251 4.26054L3.49376 8.27928L7.5125 12.298"
      stroke="black"
      strokeWidth="1.5"
    />
    <path d="M4 16.6902L19.5957 16.6902" stroke="black" strokeWidth="1.5" />
    <path
      d="M16.0489 20.7395L20.0676 16.7207L16.0489 12.702"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);
